/** @format — Normalize AG-UI component envelopes from stream/batch */

import { getAguiComponent } from "./registry";

export function normalizeAguiComponent(raw) {
  if (!raw || typeof raw !== "object") return null;
  const name = raw.name;
  if (!name || typeof name !== "string") return null;
  if (!getAguiComponent(name)) return null;
  return {
    id: raw.id ?? `cmp_${Date.now()}`,
    name,
    schemaVersion: raw.schemaVersion ?? 1,
    position: raw.position ?? "append",
    kind: raw.kind ?? "primary",
    props: raw.props && typeof raw.props === "object" ? raw.props : {},
  };
}

export function normalizeAguiComponents(raw) {
  if (raw == null) return [];
  const list = Array.isArray(raw) ? raw : [raw];
  return list.map(normalizeAguiComponent).filter(Boolean);
}

export function filterKnownUiComponents(blocks) {
  if (!Array.isArray(blocks)) return [];
  return blocks.filter((b) => b?.name && getAguiComponent(b.name));
}

/** AG-UI blocks shown in tracking chat (map data stays in stream for the map panel). */
const TRACKING_CHAT_HIDDEN = new Set(["tracking.map"]);

export function filterTrackingChatUiComponents(blocks) {
  return filterKnownUiComponents(blocks).filter((b) => !TRACKING_CHAT_HIDDEN.has(b.name));
}

/** Apply JSON-patch style STATE_DELTA ops to ui_components */
export function applyStateDelta(uiComponents, delta) {
  let result = [...(uiComponents || [])];

  for (const op of delta || []) {
    if (!op || typeof op !== "object") continue;

    if (op.op === "add" && op.path === "/ui_components") {
      const items = Array.isArray(op.value) ? op.value : [op.value];
      for (const item of items) {
        const norm = normalizeAguiComponent(item);
        if (norm) {
          const idx = result.findIndex((c) => c.id === norm.id);
          if (idx >= 0) result[idx] = norm;
          else result.push(norm);
        }
      }
    } else if (
      (op.op === "replace" || op.op === "set") &&
      op.path === "/ui_components"
    ) {
      result = normalizeAguiComponents(op.value);
    } else if (op.op === "remove" && op.path?.startsWith("/ui_components")) {
      const match = op.path.match(/\/ui_components\/(\d+)/);
      if (match) {
        const i = Number(match[1]);
        if (!Number.isNaN(i)) result.splice(i, 1);
      }
    }
  }

  return filterKnownUiComponents(result);
}
